import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

const APP_NAME = "BTC Ticker";

function App() {
  const [price, setPrice] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPrice() {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd",
        );
        if (!response.ok) throw new Error("Failed to fetch price");
        const data = await response.json();
        const btcPrice = data.bitcoin?.usd;
        if (btcPrice === undefined) throw new Error("Price data not found");
        setPrice(btcPrice.toLocaleString());
      } catch (err) {
        setError(err instanceof Error ? err.message : "An unknown error occurred");
      } finally {
        setLoading(false);
      }
    }

    fetchPrice();
    const interval = setInterval(fetchPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main
      style={{
        fontFamily: "system-ui, sans-serif",
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{APP_NAME}</h1>
      <div
        style={{
          fontSize: "4rem",
          fontWeight: "bold",
          color: "#f7931a",
          margin: "1rem 0",
        }}
      >
        {loading ? "Loading..." : error ? "Error" : `$${price}`}
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && !error && <p style={{ color: "#666" }}>Live Bitcoin Price (USD)</p>}
    </main>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
